import api from '../api';
import React, { useState, useEffect } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import googleImage from '../images/google.png';
import '../scss/pages/Login.scss'
import Lottie from 'react-lottie-player';
import { useParams } from 'react-router-dom';
import userAnimation from '../animations/user.json';
import companyAnimation from '../animations/company.json';

export default function Login({user, setUser}) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const {newType} = useParams();
    const [register, setRegister] = useState(newType ? true : false);
    const [type, setType] = useState(newType || 'individual');
    const [name, setName] = useState('');
    const [surname, setSurname] = useState('');
    const [error, setError] = useState(null);
    const [tmpUser, setTmpUser] = useState(null);

    const lg = useGoogleLogin({
        onSuccess: (codeResponse) => setTmpUser(codeResponse),
        onError: (error) => console.log('Login Failed:', error)
    });
    const setPage = () => {
        setEmail('');
        setPassword('');
        setRegister(!register);
        setError(null);
        setType('individual');
    }
    const submitRegistration = (e) => {
        e.preventDefault();
        if(!email){
            setError('Please fill in your email')
            return;
        }
        if (!password) {
            setError('Please fill in your password')
            return;
        }
        if (!name) {
            setError('Please fill in your name')
            return;
        }
        if (!surname) {
            setError('Please fill in your surname')
            return;
        }
        api.register(email, password, type, name, surname)
        .then(({data}) => {
            if(data.status === 'SUCCESS'){
                updateInfo(data.data);
            }else{
                setError(data.data);
            }
        })
        .catch((e) => {
            setError('An error occured.');
        })
    }
    const submitLogin = (e) => {
        e.preventDefault();
        setError(null);
        api.login(email, password)
        .then(({ data }) => {
            if (data.status === 'SUCCESS') {
                updateInfo(data.data)
            } else {
                setError(data.data);
            }
        })
        .catch((e) => {
            setError('An error occured. Please make sure you have the right credentials');
            console.log(e);
        })
        .finally(() => {

        })
    }
    const updateInfo = (data) => {
        setUser(data);
        localStorage.setItem('user', JSON.stringify(data));
        window.location.reload();
    }
    useEffect(() => {
        if (tmpUser) {
            api.googleLogin(tmpUser.access_token, type)
            .then(({data}) => {
                if (data.status === 'SUCCESS') {
                    updateInfo(data.data);
                } else {
                    setError(data.data);
                }
            })
            .catch((e) => {
                console.log(e);
            })
        }
    }, [tmpUser]);
    return(
        <div className="flex flex-wrap justify-evenly mt-[50px]">
            { !register &&
                <div className={`card login__form ${error && 'login__form-error'}`}>
                    <form className='m-auto flex flex-col' onSubmit={submitLogin}>
                        <h3 className="text__primary">Login</h3>
                        <div className="form__group text__left">
                            <label className='text-left'>Enter your e-mail</label>
                            <div className="input__wrap">
                                <input placeholder="Type here" type="email"  value={email} onChange={(e) => setEmail(e.target.value)} />
                                <span className="focus"></span>
                            </div>
                        </div>
                        <div className="form__group text__left">
                            <label className='text-left'>Enter password</label>
                            <div className="input__wrap">
                                <input placeholder="Type here" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                <span className="focus"></span>
                            </div>
                        </div>
                        {error && <div className='text__danger'>{error}</div> }
                        <button className="btn btn__primary btn__100">
                            Login
                        </button>
                    </form>
                    <div className="mt-5 mb-5">
                        <h4>Alternatively</h4>
                        <button className="btn btn__secondary-outline btn__100" onClick={() => lg()}>
                            <img src={googleImage} width={20} style={{display: 'inline-block'}} />
                            &nbsp;
                            &nbsp;
                            <span>Sign in with Google</span>
                        </button>
                    </div>                   
                    <a onClick={setPage} className=''>Don't have an account? Register.</a>
                </div>
            }
            {register &&
                <div className={`card login__form ${error && 'login__form-error'}`}>
                    <form className='m-auto flex flex-col' onSubmit={submitRegistration}>
                        <h3 className="text__primary">Register</h3>
                        <div className="form__group text__left">
                            <label className='text-left'>Enter your e-mail</label>
                            <div className="input__wrap">
                                <input placeholder="Type here" type="email"  value={email} onChange={(e) => setEmail(e.target.value)} />
                                <span className="focus"></span>
                            </div>
                        </div>
                        <div className="form__group text__left">
                            <label className='text-left'>Enter password</label>
                            <div className="input__wrap">
                                <input placeholder="Type here" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                                <span className="focus"></span>
                            </div>
                        </div>
                        <div className="form__group text__left">
                            <label className='text-left'>Name</label>
                            <div className="input__wrap">
                                <input placeholder="Type here" type="text" value={name} onChange={(e) => setName(e.target.value)} />
                                <span className="focus"></span>
                            </div> 
                        </div>
                        <div className="form__group text__left">
                            <label className='text-left'>Surname</label>
                            <div className="input__wrap">
                                <input placeholder="Type here" type="text" value={surname} onChange={(e) => setSurname(e.target.value)} />
                                <span className="focus"></span>
                            </div>
                        </div>
                        <div className="form__group text__left">
                            <label>Account Type</label>
                            <div className="flex flex__row text__center justify--center">
                                <div className={`btn btn__50 btn__nohover ${type === 'individual' ? 'btn__primary-outline' : 'btn__secondary'}`} onClick={() => setType('individual')}>
                                    <Lottie
                                        loop={true}
                                        animationData={userAnimation}
                                        play
                                        style={{ width: 120, height: 120, margin: 'auto' }}
                                    />
                                    <h5>Individual</h5>
                                    <div className="text__muted font__12 text__left text__normal">
                                        Create job specific interviews and practice on your skills before the actual interview.
                                    </div>
                                </div>
                                <div className={`btn btn__50 btn__nohover ${type === 'company' ? 'btn__primary-outline' : 'btn__secondary'}`} onClick={() => setType('company')}>
                                    <Lottie
                                        loop={true}
                                        animationData={companyAnimation}
                                        play
                                        style={{ width: 120, height: 120, margin: 'auto' }}
                                    />
                                    <h5>Company</h5>
                                    <div className="text__muted font__12 text__left text__normal">
                                        Create interviews to automatically screen your candidates using AI.
                                    </div>
                                </div>
                            </div>
                        </div>
                        { error && <div className='text__danger'>{error}</div> }
                        <button className="btn btn__primary btn__100">
                            Register
                        </button>
                    </form>
                    <div className="mt-5 mb-5">
                        <h4>Alternatively</h4>
                        <button className="btn btn__secondary-outline btn__100" onClick={() => lg()}>
                            <img src={googleImage} width={20} style={{display: 'inline-block'}} />
                            &nbsp;
                            &nbsp;
                            <span>Register with Google</span>
                        </button>
                    </div>                   
                    <a onClick={setPage} className=''>Already have an account? Login.</a>
                </div>
            }
        </div>
       
    )
}